import moment from "moment";

export const getFormattedDateForUser = (date) => {
    if (!date) return '';
    const formattedDate = moment(date).format('MM/DD/YYYY');
    return formattedDate;
}

export const getFormattedTimeForUser = (time) => {
    if (!time) return '';
    const formattedTime = moment(time, 'HH:mm:ss').format('hh:mm A');
    return formattedTime;
}

export const getFormattedTimeAs24Hours = (time) => {
    if (!time) return '';
    const formattedTime = moment(time, 'HH:mm:ss').format('HH:mm');
    return formattedTime;
}

